import {JobType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const JobTypeLabels: Map<JobType, StateLabel<JobType>> = new Map([
    [JobType.ArGeneration, {state: JobType.ArGeneration, label: "AR Generation"}],
    [JobType.Baking, {state: JobType.Baking, label: "Baking"}],
    [JobType.BatchDownload, {state: JobType.BatchDownload, label: "Batch Download"}],
    [JobType.DataObjectThumbnails, {state: JobType.DataObjectThumbnails, label: "Data Object Thumbnails"}],
    [JobType.Generic, {state: JobType.Generic, label: "Generic"}],
    [JobType.MaterialAi, {state: JobType.MaterialAi, label: "Material AI"}],
    [JobType.MaterialMapsExport, {state: JobType.MaterialMapsExport, label: "Material Maps Export"}],
    [JobType.MaterialOutputsPublishing, {state: JobType.MaterialOutputsPublishing, label: "Material Outputs Publishing"}],
    [JobType.MaterialShaderBall, {state: JobType.MaterialShaderBall, label: "Material Shader Ball"}],
    [JobType.MaterialThumbnail, {state: JobType.MaterialThumbnail, label: "Material Thumbnail"}],
    [JobType.MaterialTileableImage, {state: JobType.MaterialTileableImage, label: "Material Tileable Image"}],
    [JobType.RenderScene, {state: JobType.RenderScene, label: "Render Scene"}],
    [JobType.RenderTemplate, {state: JobType.RenderTemplate, label: "Render Template"}],
    [JobType.TemplateThumbnail, {state: JobType.TemplateThumbnail, label: "Template Thumbnail"}],
    [JobType.TextureSetRevisionThumbnails, {state: JobType.TextureSetRevisionThumbnails, label: "Texture Set Thumbnails"}],
    [JobType.UploadProcessing, {state: JobType.UploadProcessing, label: "Upload Processing"}],
])
